module.exports = __webpack_public_path__ + "img/client.a6ff7eb4.gif";